import { render, staticRenderFns } from "./AssignStatusButton.vue?vue&type=template&id=74d4e033&"
import script from "./AssignStatusButton.vue?vue&type=script&lang=js&"
export * from "./AssignStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports